import { render, staticRenderFns } from "./cv2.vue?vue&type=template&id=0755ca73&scoped=true&"
import script from "./cv2.vue?vue&type=script&lang=js&"
export * from "./cv2.vue?vue&type=script&lang=js&"
import style0 from "./cv2.vue?vue&type=style&index=0&id=0755ca73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755ca73",
  null
  
)

export default component.exports